import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import NotFoundImg from '../../../assets/images/pagenotfonund.svg';
import BackArrow from '../../../assets/images/icons/backarrow.svg';
import {Helmet} from 'react-helmet'
import { isAuthenticated } from "./../../utils";

function PageNotFound() {
    return (
        <div className="error-pages-wrap pagenot-found">
            <Helmet>
                <title>
                DevDiscovery | Page not found
                </title>
            </Helmet>
            <Container>
                <div className="whitebox padding-box d-flex align-items-center justify-content-center text-center m-t-40 p-relative">
                    <div className="backarrow-wrap positioned-backarrow">
                        {isAuthenticated()?
                        <Link to="/chatai"><span><img src={BackArrow} /></span></Link>:<Link to="/"><span><img src={BackArrow} /></span></Link>
                        }
                        
                    </div>
                    <div className="errorpages-content">
                        <div className="error-image">
                            <img src={NotFoundImg} alt="404" />
                        </div>
                        <h3 className="error-title m-t-30">The page cannot be found</h3>
                        <p>The requested URL was not found on this server.</p>
                        <div className="btn-wrap text-center m-t-30">
                            <Link to="/" className="btn btn-primary link-btn">Back to Home</Link>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default PageNotFound;
